<template>
    <div class="relative">
        <div class="flex items-center gap-4 relative">
            <input
                type="text"
                name="properties_query"
                id="properties-query"
                v-model="propertiesQuery"
                class="block w-full h-10 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 px-4 text-gray-800 dark:text-gray-100 text-sm placeholder:text-slate-500 dark:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm"
                placeholder="Hotel"
                v-debounce="500"
                @input="propertiesInput"
                autocomplete="off"
            />
            <Icon
                icon="check"
                class="text-green-500 absolute right-11 top-1.5"
                v-if="propertyChosen"
            />
            <ClearInputButton
                :onClear="clearPropertySearch"
                class=""
                v-if="propertiesQuery"
            />
        </div>
        <span
            class="text-gray-500 dark:text-gray-400 absolute right-12 top-1.5 z-10"
            v-if="loadingProperties"
        >
            <i class="fal fa-spinner-third fa-spin mr-1"></i>
        </span>
        <transition name="fade">
            <div
                class="absolute left-0 right-0 top-full pt-2 z-40"
                v-if="properties.length > 0 || isSearching"
            >
                <ul
                    class="w-full max-h-40 overflow-y-auto p-2 bg-white dark:bg-slate-800 rounded-lg shadow mb-1"
                    v-if="properties.length > 0"
                >
                    <li
                        v-for="(prop, pIndex) in properties"
                        :key="`property-${pIndex}`"
                        @click="selectProperty(prop)"
                        class="w-full cursor-pointer p-2 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors rounded-md flex items-center justify-between"
                        role="button"
                    >
                        <span class="text-sm">{{ prop.name }}</span>
                    </li>
                </ul>
                <button
                    type="button"
                    @click="useName()"
                    class="bg-white dark:bg-slate-800 rounded-lg shadow w-full p-2 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
                    role="button"
                >
                    <span
                        class="block w-full text-blue-400 text-xs text-center"
                    >
                        Use "{{ propertiesQuery }}"
                    </span>
                </button>
            </div>
        </transition>
    </div>
</template>
<script setup>
import { ref, watch, computed } from 'vue';
import { useTripsStore } from '@/store/trips';
import ClearInputButton from '@/components/ui/clear-input-button/clear-input-button.vue';
import Icon from '@/components/ui/icon/icon.vue';

const tripStore = useTripsStore();

const props = defineProps({
    hotel: {
        type: String,
        default: null,
    },
});
const emit = defineEmits(['propertyChanged', 'clearSelected']);

const isSearching = ref(false);
const loadingProperties = ref(false);
const propertyChosen = ref(false);
const propertiesQuery = ref(null);
const propertySelected = ref(false);
const properties = ref([]);
const queryStartLength = ref(2);
const choseCustom = ref(false);

const property = computed(() => {
    return props.hotel;
});

watch(
    property,
    (val) => {
        if (val) {
            propertiesQuery.value = val;
            propertyChosen.value = true;
            propertySelected.value = true;
        }
    },
    { immediate: true }
);

const propertiesInput = () => {
    if (
        propertiesQuery.value &&
        propertiesQuery.value.length > queryStartLength.value &&
        !choseCustom.value
    ) {
        isSearching.value = true;
        loadingProperties.value = true;
        ApiService.apiCall('/hotels/properties-typeahead', 'get', {
            search_query: propertiesQuery.value,
        })
            .then((response) => {
                properties.value = response.data;
                loadingProperties.value = false;
            })
            .catch(() => {
                loadingProperties.value = false;
                isSearching.value = false;
            });
    } else {
        properties.value = [];
        loadingProperties.value = false;
        isSearching.value = false;
    }
};

const selectProperty = (property) => {
    propertySelected.value = true;
    propertiesQuery.value = property.name;
    propertyChosen.value = property;
    properties.value = [];
    isSearching.value = false;
    emit('propertyChanged', property);
};

const useName = () => {
    properties.value = [];
    isSearching.value = false;
    choseCustom.value = true;
    propertyChosen.value = true;
    tripStore.activeRedemption.name = propertiesQuery.value;
    emit('clearSelected');
};

const clearPropertySearch = () => {
    isSearching.value = false;
    propertiesQuery.value = null;
    properties.value = [];
    propertyChosen.value = false;
    propertySelected.value = false;
    tripStore.activeRedemption.name = null;
    choseCustom.value = false;
    emit('propertyChanged', null);
};
</script>
